$(function() {
  $('#all-regions').click(function () {
    $('.region-row').show()
  });

  $('.letter-select').click(function (event) {
    $('.region-row').hide();
    $(`.region-row[data-letter="${event.target.text}"]`).show();
  });

  $('.letters-list-item').click(function (event) {
    $('.letters-list-item_active').removeClass('letters-list-item_active');
    $(event.target).parent('li').addClass('letters-list-item_active');
  });
});
